export default function createShapeLinksWorker() {
  return new Worker(new URL('./worker.js', import.meta.url));
}
